import { Fraction } from 'bi-fraction';

const getPositiveOrZeroFraction = (num?: Fraction) => {
  if (!num) return Fraction.ZERO;
  return num.gt(Fraction.ZERO) ? num : Fraction.ZERO;
};

export default getPositiveOrZeroFraction;
